<table class="styled" *ngIf="prices && sizes">
  <tr *ngFor="let size of sizes">
    <td>{{size}}</td>
    <td>
      <mat-form-field class="fullwidth">
        <label>{{ 'Pris' | translate }}</label>
        <input matInput type="number" [(ngModel)]="prices[size]" />
      </mat-form-field>
    </td>
  </tr>
</table>
